export default __webpack_public_path__ + "ocr881ab2.svg";